import dynamic from 'next/dynamic';
const SafeHtml = dynamic(() => import('./SafeHtml/SafeHtml'));
const StickyBox = dynamic(() => import('./StickyBox/StickyBox'));

export {default as Filter} from './Filter/Filter';
export {default as StickyCta} from './StickyCta/StickyCta';
export { SafeHtml };
export { StickyBox };
